const DELIVERY_QUOTE_ERROR_CODES = new Set([
  'delivery_no_location',
  'delivery_outside_zone',
  'restaurant_delivery_not_configured',
  'restaurant_does_not_deliver_to_zone',
  'delivery_tariff_not_configured',
  'customer_zone_not_available',
  'restaurant_blocked',
  'resto_not_found',
])

const MARK_OUTSIDE_ZONE_CODES = new Set([
  'delivery_outside_zone',
  'restaurant_does_not_deliver_to_zone',
])

const OPS_DELIVERY_ERROR_CODES = new Set([
  'restaurant_delivery_not_configured',
  'delivery_tariff_not_configured',
  'customer_zone_not_available',
  'restaurant_blocked',
  'resto_not_found',
])

export function isDeliveryQuoteError(error) {
  const code = typeof error?.code === 'string' ? error.code.trim() : ''
  return DELIVERY_QUOTE_ERROR_CODES.has(code)
}

export function shouldMarkOutsideDeliveryZone(error) {
  const code = typeof error?.code === 'string' ? error.code.trim() : ''
  return MARK_OUTSIDE_ZONE_CODES.has(code)
}

export function resolveDeliveryQuoteErrorMessage(error, t, te) {
  const code = typeof error?.code === 'string' ? error.code.trim() : ''

  if (OPS_DELIVERY_ERROR_CODES.has(code)) {
    return t('common.cartDeliveryUnavailable')
  }

  const key = code ? `common.cartDeliveryErrors.${code}` : ''
  if (key && te(key)) {
    return t(key)
  }

  return t('common.cartDeliveryQuoteFailed')
}
